var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"detailsTitle"},[_c('h4',[_vm._v("客户管理")]),_c('div',{on:{"click":_vm.back}},[_c('i',{staticClass:"fa fa-reply"})])]),_c('customerManage',{attrs:{"ZtenantCode":_vm.tenantCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }